<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="structure-bnxt1" id="calibre_pb_29"><span class="bold1"> </span></p>
<p class="body_heading"><span class="bold2">Dirty Dozen plus One</span></p>
<p class="icon"> </p>
<p class="body_numbers"><span class="bold3">1.</span>St<span>rawberries</span></p>
<p class="body_numbers"><a href="https://www.ewg.org/foodnews/spinach.php" target="_blank"><span class="bold3">2.</span>Spinach</a></p>
<p class="body_numbers"><span class="bold3">3.</span>Kale</p>
<p class="body_numbers"><span class="bold3">4.</span><span>Nectarines</span></p>
<p class="body_numbers"><span class="bold3">5.</span>Apples</p>
<p class="body_numbers"><span class="bold3">6.</span>Grapes</p>
<p class="body_numbers"><span class="bold3">7.</span>Peaches</p>
<p class="body_numbers"><span class="bold3">8.</span>Cherries</p>
<p class="body_numbers"><span class="bold3">9.</span>Pears</p>
<p class="body_numbers"><span class="bold3">10.</span>Tomatoes</p>
<p class="body_numbers"><span class="bold3">11.</span>Celery</p>
<p class="body_numbers"><span class="bold3">12.</span>Potatoes</p>
<p class="body_numbers1" id="calibre_pb_30"><span class="bold3">13.</span>Sweet be<span>ll</span><span> </span><span>peppers</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_017.vue?07ae32ce